import React from 'react';
import PropTypes from 'prop-types';
import { AutoComplete, Checkbox, message, Row, Col } from 'antd';
import remove from 'lodash/remove';
import compact from 'lodash/compact';
import { InfoCircleOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import endpoints, { GRAPH_URL } from '~settings/endpoints';
import enhanceForm from '~hocs/enhance-form';
import cookies from 'js-cookie';
import axios from 'axios';
import { cookieNames } from '~constants';
import { propertyStatus, documentationTimeValue } from '~constants/listing-management';
import PropertyDetailWrapper from '~components/property-detail-wrapper';
import { bookingJourneyType } from 'common/constants/booking';

import * as queries from '~settings/queries';
import { bindPropertyUniversities, bindPropertyDocumentations } from '~settings/pms-queries';
import { getItem } from '~helpers/storage';
import europeanCountries from 'common/helpers/european-countries';

const FormItem = Form.Item;
@enhanceForm()
export default class AcceptanceCriteria extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      universities: [],
      selectedOption: [],
      checkedRequestDocuments: [],
    };
    this.isPublished = props.property.status === propertyStatus.PUBLISHED;
    this.isLongtail = props.property.bookingJourney === bookingJourneyType.SEMI_AUTOMATIC;
    this.hasRequestedDocument =
      this.isLongtail && europeanCountries.indexOf(props.property?.country) === -1;
  }

  getUniversities = value => {
    const authorization = `Bearer ${cookies.get(cookieNames.token)}`;
    const headers = {
      Authorization: authorization,
      'Accept-Language': 'en-us',
    };
    const authPayload = getItem('PMS_CURRENT_USER_AUTH');

    if (authPayload && authPayload.payload && authPayload.payload.currentRoleSlug) {
      headers['Current-Role'] = authPayload.payload.currentRoleSlug;
    }
    if (value) {
      axios({
        method: 'post',
        url: endpoints.search.url('university'),
        data: queries.searchUniversity(
          {
            pageNumber: 1,
            pageSize: 10,
            publishedStatus: 'PUBLISHED',
            query: value,
          },
          'university',
        ),
        headers,
      })
        .then(response => {
          this.setState({
            universities: response.data.data.search.edges,
          });
        })
        .catch(() => {
          message.error(this.props.t('cms.message.error'));
        });
    }
  };

  handleClickSave = () =>
    new Promise((resolve, reject) => {
      const { property, afterSave } = this.props;
      const { checkedRequestDocuments, selectedOption } = this.state;
      const fildVaule = selectedOption[0]?.id ?? [];
      let bindPropertyDocumentationsRequest = null;
      const propertyDocumentations =
        checkedRequestDocuments.length > 0 && this.hasRequestedDocument
          ? checkedRequestDocuments.map(item => ({
              documentationSlug: item,
              documentationTimeValue: documentationTimeValue.BEFORE_SUBMIT_ORDER,
            }))
          : [];

      const authorization = `Bearer ${cookies.get(cookieNames.token)}`;
      const headers = {
        Authorization: authorization,
        'Accept-Language': 'en-us',
      };
      const authPayload = getItem('PMS_CURRENT_USER_AUTH');
      if (authPayload?.payload?.currentRoleSlug) {
        headers['Current-Role'] = authPayload.payload.currentRoleSlug;
      }

      const bindPropertyUniversitiesRequest = axios({
        method: 'post',
        url: GRAPH_URL,
        data: bindPropertyUniversities({
          propertyId: property.id,
          universityIds: fildVaule,
          isDestinationUniversity: true,
        }),
        headers,
      });

      if (this.hasRequestedDocument) {
        bindPropertyDocumentationsRequest = axios({
          method: 'post',
          url: GRAPH_URL,
          data: bindPropertyDocumentations({
            propertyId: property.id,
            propertyDocumentations,
          }),
          headers,
        });
      }

      const requestAll = [bindPropertyUniversitiesRequest, bindPropertyDocumentationsRequest];

      axios
        .all(requestAll)
        .then(res => {
          let newDocumentations = [];
          let newProperty = property;
          if (
            (this.isLongtail &&
              res[0]?.data?.data?.bindPropertyUniversities?.result &&
              res?.[1]?.data?.data?.bindPropertyDocumentations?.result) ||
            (!this.isLongtail && res[0]?.data?.data?.bindPropertyUniversities?.result)
          ) {
            if (this.hasRequestedDocument) {
              newDocumentations = property.documentations.map(item => {
                if (checkedRequestDocuments.includes(item.slug)) {
                  return {
                    ...item,
                    check: true,
                  };
                }
                return {
                  ...item,
                  check: false,
                };
              });

              newProperty = {
                ...property,
                destinationUniversities: selectedOption,
                documentations: newDocumentations,
              };
            } else {
              newProperty = {
                ...property,
                destinationUniversities: selectedOption,
              };
            }

            afterSave(newProperty);
            resolve({ isUpdated: true, isShowUpdateHint: true });
          } else {
            reject(res?.data?.errors?.[0]?.extensions?.code);
          }
        })
        .catch(e => {
          reject(e);
        });
    });

  onChange = value => {
    this.getUniversities(value);
    if (!value) {
      this.setState({ selectedOption: [] });
      this.props.form.setFields({
        destinationUniversity: {
          value,
          errors: null,
        },
      });
    }
  };

  onSelect = (value, option) => {
    this.setState({
      selectedOption: [
        {
          id: option?.props?.value,
          name: option?.props?.children,
        },
      ],
    });
    this.props.form.setFields({
      destinationUniversity: {
        value,
        errors: null,
      },
    });
  };

  getInitValue = property => {
    return property?.destinationUniversities?.[0]?.name ?? '';
  };

  componentDidMount() {
    const { destinationUniversities, documentations } = this.props.property;

    if (documentations?.length > 0 && this.hasRequestedDocument) {
      const initialDocumentations = compact(
        documentations.map(item => {
          if (item.check) {
            return item.slug;
          }
        }),
      );

      this.setState({
        checkedRequestDocuments: initialDocumentations,
      });
    }

    if (destinationUniversities?.[0]?.id) {
      this.setState({
        selectedOption: [
          {
            id: destinationUniversities?.[0]?.id,
            name: destinationUniversities?.[0]?.name,
          },
        ],
      });
    }
  }

  handleCheckRequestDocument = e => {
    const { checkedRequestDocuments } = this.state;
    const { value } = e?.target;
    const copyCheckedRequestDocuments = [...checkedRequestDocuments];

    if (checkedRequestDocuments?.includes(value)) {
      remove(copyCheckedRequestDocuments, item => item === value);
    } else {
      copyCheckedRequestDocuments.push(value);
    }

    this.setState({
      checkedRequestDocuments: copyCheckedRequestDocuments,
    });
  };

  render() {
    const {
      isHidden,
      t,
      property,
      form: { getFieldDecorator },
    } = this.props;
    const { universities } = this.state;

    return (
      <PropertyDetailWrapper
        t={t}
        isPublished={this.isPublished}
        onClickSave={this.handleClickSave}
        isHidden={isHidden}
        isPendingApprovalSection
        property={property}
      >
        <div className="acceptance-criteria__box">
          <Form layout="vertical">
            <p className="property-detail__subtitle acceptance-criterias__subtitle">
              {t('cms:cms.properties.edit.acceptance_criteria.destination_university')}
            </p>

            <FormItem
              label={t('cms:cms.properties.edit.acceptance_criteria.destination_university')}
              colon={false}
              name="name"
            >
              {getFieldDecorator('destinationUniversity', {
                initialValue: this.getInitValue(property),
              })(
                <AutoComplete
                  showSearch
                  placeholder={t('cms:cms.properties.edit.detail.choose_university.placeholder')}
                  allowClear
                  onChange={this.onChange}
                  onSelect={this.onSelect}
                >
                  <For of={universities} each="item">
                    <AutoComplete.Option key={item.node.id} value={item.node.id}>
                      {item.node.name}
                    </AutoComplete.Option>
                  </For>
                </AutoComplete>,
              )}
            </FormItem>

            <If condition={this.hasRequestedDocument}>
              <p className="property-detail__subtitle acceptance-criterias__subtitle">
                {t('cms:cms.properties.edit.acceptance_criteria.request_document')}
              </p>
              <FormItem
                label={t('cms:cms.properties.edit.acceptance_criteria.request_document')}
                colon={false}
                name="request_document"
              >
                {getFieldDecorator('requestDocument')(
                  <>
                    <Row gutter={12}>
                      {property?.documentations.map((item, idx) => (
                        <Col span={8} key={idx} style={{ marginBottom: 12 }}>
                          <Checkbox
                            value={item?.slug}
                            defaultChecked={item?.check}
                            onChange={this.handleCheckRequestDocument}
                          >
                            {item?.label}
                          </Checkbox>
                        </Col>
                      ))}
                    </Row>
                    <div className="info-wrapper">
                      <InfoCircleOutlined className="info-icon" />
                      <span className="info-notice">
                        {t('cms:cms.properties.edit.acceptance_criteria.request_document.notice')}
                      </span>
                    </div>
                  </>,
                )}
              </FormItem>
            </If>
          </Form>
        </div>
      </PropertyDetailWrapper>
    );
  }
}

AcceptanceCriteria.propTypes = {
  t: PropTypes.func.isRequired,
  property: PropTypes.object.isRequired,
  form: PropTypes.object,
  draft: PropTypes.any,
  afterSave: PropTypes.func,
};

AcceptanceCriteria.defaultProps = {
  t: () => {},
  afterSave: () => {},
  property: {},
  isHidden: false,
};
